import React from 'react';
import OutputReportAdmin from './OutputReportAdmin';

const OutputReportsForUser = ({ api, partyId }) => {
    if (!partyId) {
        return (
            <div style={{ padding: '20px', color: 'red' }}>
                Error: Unable to determine user ID. Please reload the page.
            </div>
        );
    }

    // This page is always scoped to the party whose profile is open. The recipient
    // must never be set or cleared from the search form (see review #7), so pass it
    // as a locked value rather than as overridable initial criteria.
    const lockedRecipientPartyId = parseInt(partyId, 10);

    return (
        <div>
            <OutputReportAdmin api={api} lockedRecipientPartyId={lockedRecipientPartyId} />
        </div>
    );
};

export default OutputReportsForUser;
